/**
 * All variable types the Web SDK can collect.
 * Matches tracker-web_current VariableTypeDefinitions + Android structure.
 */
export enum TrackerVariableType {
  // --- DOM / Browser ---
  URL = "URL",
  ELEMENT = "ELEMENT",
  COOKIE = "COOKIE",
  JAVASCRIPT = "JAVASCRIPT",
  EVENT = "EVENT",

  // --- Device ---
  IP_ADDRESS = "IP_ADDRESS",
  DEVICE_FINGERPRINT = "DEVICE_FINGERPRINT",
  SCREEN_RESOLUTION = "SCREEN_RESOLUTION",
  USER_AGENT = "USER_AGENT",
  BROWSER = "BROWSER",
  OS = "OS",
  LANGUAGE = "LANGUAGE",
  TIMEZONE = "TIMEZONE",
  PLATFORM = "PLATFORM",

  // --- SDK ---
  SDK_VERSION = "SDK_VERSION",
  TIMESTAMP = "TIMESTAMP",
  ELAPSED_TIME = "ELAPSED_TIME",
  CURRENT_TRIGGER_NAME = "CURRENT_TRIGGER_NAME",
  THEME_MODE = "THEME_MODE",

  // --- Security / Risk ---
  SUSPICIOUS_ACTIVITY = "SUSPICIOUS_ACTIVITY",
  SUSPICIOUS_BROWSER = "SUSPICIOUS_BROWSER",
  REMOTE_ACCESS_SCORE = "REMOTE_ACCESS_SCORE",
  REMOTE_ACCESS_FLAGS = "REMOTE_ACCESS_FLAGS",
  ENVIRONMENT_CHANGE_FLAGS = "ENVIRONMENT_CHANGE_FLAGS",
  ENVIRONMENT_CHANGE_SCORE = "ENVIRONMENT_CHANGE_SCORE",
  NO_MOUSE_MOVE_DURATION_MS = "NO_MOUSE_MOVE_DURATION_MS",
  CLICK_ONLY_PATTERN = "CLICK_ONLY_PATTERN",
  FAST_PAGE_TRANSITION = "FAST_PAGE_TRANSITION",
  FORM_FILL_ANOMALY = "FORM_FILL_ANOMALY",
  FORM_FILL_DURATION_MS = "FORM_FILL_DURATION_MS",
  NAVIGATION_VELOCITY = "NAVIGATION_VELOCITY",
  INPUT_PASTE_RATIO = "INPUT_PASTE_RATIO",
  HEADLESS_INDICATOR_COUNT = "HEADLESS_INDICATOR_COUNT",
  REDIRECT_DETECTED = "REDIRECT_DETECTED",

  // --- Behavioral Biometrics ---
  MOUSE_DYNAMICS = "MOUSE_DYNAMICS",
  KEYSTROKE_DYNAMICS = "KEYSTROKE_DYNAMICS",
  SCROLL_BEHAVIOR = "SCROLL_BEHAVIOR",
  SESSION_BEHAVIOR = "SESSION_BEHAVIOR",
  TOUCH_DYNAMICS = "TOUCH_DYNAMICS",
  BEHAVIORAL_BIOMETRIC_SCORE = "BEHAVIORAL_BIOMETRIC_SCORE",
  BEHAVIORAL_BIOMETRIC_FLAGS = "BEHAVIORAL_BIOMETRIC_FLAGS",

  // --- Activity ---
  VIEW_DURATION = "VIEW_DURATION",

  // --- Custom ---
  CUSTOM_TRIGGER_ARGS = "CUSTOM_TRIGGER_ARGS",

  // --- Network ---
  REACHABLE = "REACHABLE",
}

// ---- Variable option types (used by backend config) ----

export type UrlSelection = "full" | "host" | "port" | "path" | "query" | "fragment" | "protocol";

export interface UrlOption {
  selection: UrlSelection;
}

export interface ElementOption {
  cssSelector: string;
  attribute?: string;
  urlSelection?: UrlSelection;
}

export interface CookieOption {
  cookieName: string;
  decodeUrlCookie?: boolean;
}

export interface JavascriptOption {
  code: string;
}

export interface HistoryOption {
  newUrl?: string;
  oldUrl?: string;
  newState?: unknown;
  oldState?: unknown;
  changeSource?: string;
}
